var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 36,
    viewBox: "0 0 39 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "location_on"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_824_10007",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 39,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.150391,
    width: 37.9726,
    height: 36,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_824_10007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "location_on_2",
    d: "M19.1423 17.5961C19.8467 17.5961 20.4478 17.3584 20.9457 16.8829C21.4438 16.4074 21.6928 15.8357 21.6928 15.168C21.6928 14.5002 21.4419 13.9303 20.9401 13.458C20.4386 12.986 19.8356 12.75 19.1313 12.75C18.4269 12.75 17.8258 12.9878 17.328 13.4633C16.8298 13.9388 16.5808 14.5104 16.5808 15.1781C16.5808 15.8459 16.8317 16.4159 17.3335 16.8881C17.8351 17.3601 18.438 17.5961 19.1423 17.5961ZM19.1368 29.5155C22.1105 27.0615 24.4615 24.5658 26.1898 22.0282C27.9181 19.4908 28.7822 17.2961 28.7822 15.4444C28.7822 12.7001 27.8659 10.4351 26.0332 8.64938C24.2005 6.86388 21.9017 5.97112 19.1368 5.97112C16.3719 5.97112 14.0731 6.86388 12.2404 8.64938C10.4077 10.4351 9.49137 12.7001 9.49137 15.4444C9.49137 17.2961 10.3555 19.4908 12.0838 22.0282C13.8121 24.5658 16.1631 27.0615 19.1368 29.5155ZM19.1368 31.5289C15.4187 28.4116 12.6179 25.5044 10.7346 22.8071C8.85098 20.1101 7.90918 17.6559 7.90918 15.4444C7.90918 12.2711 8.99905 9.65375 11.1788 7.59225C13.3582 5.53075 16.0109 4.5 19.1368 4.5C22.2627 4.5 24.9154 5.53075 27.0948 7.59225C29.2746 9.65375 30.3644 12.2711 30.3644 15.4444C30.3644 17.6559 29.4226 20.1101 27.539 22.8071C25.6557 25.5044 22.855 28.4116 19.1368 31.5289Z",
    fill: "#232323"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOn);
export default __webpack_public_path__ + "static/media/location_on.c07a9b0b43aa5618570522da40dbcd0c.svg";
export { ForwardRef as ReactComponent };